import styled from 'styled-components';
import { Box } from '@components/Box';
import Carousel from 'nuka-carousel';
import { Text } from '@components/typography';
import { themeMediaQuery, themeSpace } from '@utils/styledTheme.util';
import { cloudAssetUrl } from '@utils/cloudAssetUrl.util';
import { TOP_BANNER_HEIGHT } from '@layout';

export const StyledBox = styled(Box)`
  max-width: 516px;
  border-radius: 8px;
  padding: ${themeSpace(9)};
  ${themeMediaQuery('below_sm')} {
    padding: ${themeSpace(7)};
  }
`;

export const ImgContainer = styled.div<{ src: string }>`
  width: 100%;
  height: 100vh;
  position: absolute;
  top: 0;
  background-image: ${props => `url(${cloudAssetUrl(props.src, { optimization: 'aggressive' })})`};
  background-size: cover;
  border-radius: 0px 0px 8px 0px;
  ${themeMediaQuery('below_sm')} {
    position: relative;
    height: 250px;
  }
`;

export const Container = styled.div`
  position: relative;
  height: 777px;
  margin: 0 100px;
  ${themeMediaQuery('below_sm')} {
    margin: 0 0px;
    height: auto;
  }
`;

export const TextContainer = styled.div`
  right: -10%;
  z-index: 10;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  top: 50%;
  border-radius: 8px;
  transform: translateY(-50%);
  box-shadow: 0px 4px 100px rgba(218, 218, 218, 0.25);
  ${themeMediaQuery('below_sm')} {
    position: relative;
    height: auto;
    top: 255px;
    text-align: center;
    right: 0px;
  }
`;

export const OpeningQuote = styled.span`
  position: absolute;
  width: 61px;
  height: 32px;
  font-family: Austin News Headline;
  font-style: normal;
  font-weight: normal;
  font-size: 60px;
  line-height: 88px;
  letter-spacing: -0.015em;
  color: #333333;
  margin-top: -15px;
  ${themeMediaQuery('below_sm')} {
    margin-left: -45px;
  }
`;

export const controlStyles = {
  nextButtonStyle: {
    display: 'none',
  },
  prevButtonStyle: {
    display: 'none',
  },
  pagingDotsStyle: {
    fill: 'transparent',
    height: '12px',
    width: '12px',
    border: '2px solid #D6D6D6',
    borderRadius: '50%',
    opacity: 1,
  },
  pagingDotsClassName: 'dots',
  pagingDotsContainerClassName: 'wedding-websites-dots-vertical-carousel-container',
};

export const StyledNewsroomCarousel = styled(Carousel)`
  height: 823px;
  background-color: #ffffff;
  max-width: 1400px;
  margin: auto;
  .wedding-websites-dots-vertical-carousel-container {
    display: inline !important;
    position: relative !important;
  }

  .slider-control-bottomcenter {
    position: absolute !important;
    top: 50% !important;
    left: 50px !important;
    transform: translateY(-50%) !important;
    bottom: unset !important;
    ${themeMediaQuery('below_sm')} {
      display: none;
    }
  }

  .paging-item > button {
    display: flex !important;
    align-items: center !important;
  }

  .paging-item > button:focus {
    outline: 0;
    outline: 1px solid rgba(68, 0, 102, 1);
    outline-offset: 4px;
    background-clip: content-box;
  }

  .paging-item.active > button {
    background: #d6d6d6 !important;
  }

  ${themeMediaQuery('below_sm')} {
    height: auto;
    top: calc(50px - ${TOP_BANNER_HEIGHT}px);
  }
`;

export const DescTextContainer = styled(Text)`
  margin-left: 30px;
  display: inline-block;
  ${themeMediaQuery('below_sm')} {
    margin-left: ${themeSpace(0)};
  }
`;
